import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4.41 22H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
}), 'SignalCellular4BarRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellular4BarRounded.js
// module id = 6155
// module chunks = 2